import { render, staticRenderFns } from "./LoadSpinner.vue?vue&type=template&id=151c98fa&scoped=true"
import script from "./LoadSpinner.vue?vue&type=script&lang=js"
export * from "./LoadSpinner.vue?vue&type=script&lang=js"
import style0 from "./LoadSpinner.vue?vue&type=style&index=0&id=151c98fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151c98fa",
  null
  
)

export default component.exports